import { render } from "./TeacherClassSwitcher.vue?vue&type=template&id=385c0425&scoped=true"
import script from "./TeacherClassSwitcher.vue?vue&type=script&lang=js"
export * from "./TeacherClassSwitcher.vue?vue&type=script&lang=js"

import "./TeacherClassSwitcher.vue?vue&type=style&index=0&id=385c0425&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385c0425"]])

export default __exports__